import axiosInstance from './AxiosInstance';

const BASE = '/task/performance';

export const getMyPerformance = (period = 30) =>
  axiosInstance.get(`${BASE}/me`, { params: { period } });

export const getMyTrends = (period = 30, points = 6) =>
  axiosInstance.get(`${BASE}/me/trends`, { params: { period, points } });

export const getMyPeriodScores = (params = {}) =>
  axiosInstance.get(`${BASE}/me/period-scores`, { params });

export const getMyAtRisk = () =>
  axiosInstance.get(`${BASE}/me/at-risk`);

export const getTeamLeaderboard = (params = {}) =>
  axiosInstance.get(`${BASE}/team`, { params: { period: 30, ...params } });

export const getTeamPeriodScores = (params = {}) =>
  axiosInstance.get(`${BASE}/team/period-scores`, { params });

export const getTaskAnalytics = (params = {}) =>
  axiosInstance.get(`${BASE}/task-analytics`, { params });

export const getUserPerformance = (userId, period = 30) =>
  axiosInstance.get(`${BASE}/user/${userId}`, { params: { period } });

export const getMyBadges = () =>
  axiosInstance.get(`${BASE}/badges/me`);

export const getBadgeDefinitions = () =>
  axiosInstance.get(`${BASE}/badges/definitions`);

export const exportTeamXlsx = (period = 30) =>
  axiosInstance.get(`${BASE}/team/export-xlsx`, {
    params: { period },
    responseType: 'blob',
  });
